@if (showLoader) {
<app-results-loader></app-results-loader>
}
<div class="inner-container">
    <div class="flex" (click)="back()">
        <mat-icon class="rtl-icon">arrow_back</mat-icon> <span>{{ 'fullResults.back' | translate }}</span>
    </div>
    <div class="card-main">
        <div class="image-container">
            <img src="../../assets/images/question-mystery-symptoms.webp" [alt]="'fullResults.questionMark' | translate" />
        </div>
        <div class="text-container">
            <h3>
                {{ 'fullResults.understandingPrefix' | translate }} <span class="highlight">{{ 'fullResults.your' | translate }}</span> {{ 'fullResults.understandingSuffix' | translate }}
            </h3>
        </div>
    </div>
    @for (symptom of symptomsInfo; track symptom) {
    <div class="image-card" (click)="showSymptomsInfo(symptom.slug)">
        <img src="{{symptom.image}}" alt={{symptom.title}}>
        <p>{{symptom.title}}</p>
    </div>
    }
</div>